import React from 'react';

const LearnPositioning = () => {
  return (
    <div>
      <p>
        Let staff know why you are undertaking the survey and why it is
        important for them to participate. An example message is included in the
        guide you can download. Letting them know it is anonymous and that
        results will be shared is also important to engage everyone and make
        sure all staff see themselves as being part of any actions that will be
        taken.
      </p>
    </div>
  );
};

export default LearnPositioning;
